import HarvestKpiDashboard from './HarvestKpiDashboard';

export default HarvestKpiDashboard;
